import { baseUrl } from '@/settings'
import { get, post } from '../rest'

const session = {
    loginUrl: (forceful, creds) => post(`${baseUrl}/user/account/login${forceful ? '?forceful=true' : ''}`, creds),
    createUrl: () => post(`${baseUrl}/user/account/createsession`),
    logoutUrl: () => get(`${baseUrl}/user/account/logout`),
    checkSessionUrl: () => post(`${baseUrl}/user/account/checkSession`),
    verifyOtp: (username, otp, forceful) => post(`${baseUrl}/user/account/verifylogin`, { username, otp, forceful }),
    backupCodeLogin: (username, backupCode, forceful) => post(`${baseUrl}/user/account/backupCodeLogin`, { username, backupCode, forceful }),
    resendOtp: (username) => post(`${baseUrl}/user/account/resendotp`, { username })
}
export default session
